import type { SVGProps } from 'react';
import type SVGType from 'types/svg.types';

const CalendarAppointmentBoldIcon: SVGType = (
  props: SVGProps<SVGSVGElement> & {
    fillColor?: string;
  },
) => {
  const { fillColor = '#F6F3FE', ...restProps } = props;

  return (
    <svg
      viewBox="0 0 72 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <g clipPath="url(#clip0_11184_102378)">
        <path
          d="M63.0042 40.2526C63.0042 42.8883 63.2045 49.941 62.9078 51.784C61.9489 57.7418 57.5177 57.1083 53.4715 57.4886C47.5948 57.4886 43.1113 57.3619 41.8145 57.3619C39.5988 57.3619 36.3233 57.8686 34.2038 57.8686C32.0844 57.8686 30.832 57.6151 25.9187 57.8686C21.0055 58.122 14.3581 59.3893 12.1375 54.8253C10.4648 51.3872 11.6559 43.4206 11.2705 39.7457C10.8851 36.0708 11.1742 30.6216 11.1742 26.3134C11.1742 22.4657 11.2705 23.7986 11.2705 19.726C11.2705 10.8536 13.999 10.4756 24.4736 10.4749C28.3272 10.4747 36.5159 10.2215 40.8512 10.2215C44.6195 10.2215 48.5534 11.107 53.1777 10.8536C56.8771 10.6508 57.9067 10.6022 60.1182 12.8832C63.3022 16.1673 62.9078 21.5001 62.9078 22.5118C62.9078 26.4401 63.0042 36.9579 63.0042 40.2526Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="3.31203"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M58.9139 43.9648C58.9139 46.4304 59.1155 53.0276 58.8169 54.7516C57.8516 60.3246 53.3912 59.732 49.3182 60.0877C43.4027 60.0877 38.8895 59.9692 37.5842 59.9692C35.3538 59.9692 32.0567 60.4431 29.9232 60.4431C27.7898 60.4431 26.5291 60.2061 21.5834 60.4431C16.6377 60.6802 9.9464 61.8657 7.71114 57.5964C6.02732 54.3804 6.74139 47.2782 6.7414 43.6785L6.7414 30.9259C6.7414 27.3267 6.83837 28.5736 6.83837 24.7639C6.83837 16.4645 9.58486 16.111 20.1288 16.1103C24.0078 16.1101 32.2506 15.8733 36.6145 15.8733C40.4077 15.8733 44.3677 16.7016 49.0225 16.4645C52.7463 16.2749 53.7828 16.2294 56.0088 18.363C59.2139 21.435 58.8169 26.4234 58.8169 27.3698C58.8169 31.0444 58.9139 40.8829 58.9139 43.9648Z"
          fill={fillColor}
          stroke="currentColor"
          strokeWidth="2.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M63.4768 16.388C63.4701 16.404 63.4608 16.4354 63.4481 16.4902C63.188 17.6168 62.5421 17.8807 61.2943 18.3843C59.3098 19.1853 58.4776 18.996 58.1258 18.996C57.5248 18.996 56.1787 19.2797 55.6038 19.2797C55.0289 19.2797 54.6755 19.2319 53.3427 19.2798C52.01 19.3277 50.2788 19.8591 49.6764 18.996C49.2227 18.3459 49.5458 16.8394 49.4412 16.1445C49.3367 15.4495 49.4151 14.4191 49.4151 13.6044C49.4151 12.8768 49.4412 13.1288 49.4412 12.3587C49.4412 10.6809 50.1813 10.6094 53.0226 10.6093C54.0679 10.6093 53.2984 10.2756 54.4743 10.2756C55.4965 10.2756 56.9695 10.057 58.3877 10.5042C59.8672 10.9706 62.1712 11.7244 62.7711 12.1558C63.6348 12.7768 63.4481 14.0603 63.4481 14.2516C63.4481 14.9945 63.4743 15.6173 63.4743 16.2403C63.4742 16.3081 63.4753 16.3556 63.4768 16.388C63.4848 16.5564 63.507 16.316 63.4768 16.388Z"
          fill="currentColor"
        />
        <path
          d="M63.4481 16.4902C63.5286 16.1416 63.4742 16.7387 63.4743 16.2403C63.4743 15.6173 63.4481 14.9945 63.4481 14.2516C63.4481 14.0603 63.6348 12.7768 62.7711 12.1558C62.1712 11.7244 59.8672 10.9706 58.3877 10.5042C56.9695 10.057 55.4965 10.2756 54.4743 10.2756C53.2984 10.2756 54.0679 10.6093 53.0226 10.6093C50.1813 10.6094 49.4412 10.6809 49.4412 12.3587C49.4412 13.1288 49.4151 12.8768 49.4151 13.6044C49.4151 14.4191 49.3367 15.4495 49.4412 16.1445C49.5458 16.8394 49.2227 18.3459 49.6764 18.996C50.2788 19.8591 52.01 19.3277 53.3427 19.2798C54.6755 19.2319 55.0289 19.2797 55.6038 19.2797C56.1787 19.2797 57.5248 18.996 58.1258 18.996C58.4776 18.996 59.3098 19.1853 61.2943 18.3843C62.5421 17.8807 63.188 17.6168 63.4481 16.4902Z"
          stroke="currentColor"
          strokeWidth="3.31203"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M58.9895 16.0389C58.9895 16.6788 59.2106 18.3912 58.8832 18.8386C57.8251 20.2852 52.9356 20.1313 48.4709 20.2237C41.9865 20.2237 37.0392 20.1929 35.6084 20.1929C33.1635 20.1929 29.5492 20.3159 27.2106 20.3159C24.8719 20.3159 23.49 20.2544 18.0686 20.3159C12.6472 20.3775 4.86809 21.0904 2.86214 19.577C1.90542 18.8553 1.90543 17.2567 1.90543 15.9158C1.90542 14.9708 1.79913 13.7006 1.79913 12.6546C1.79913 11.7204 1.90543 12.044 1.90543 11.0552C1.90543 8.90106 4.91607 8.80928 16.4741 8.80912C20.7261 8.80906 29.7618 8.74759 34.5454 8.74759C38.7034 8.74759 43.0443 8.96259 48.1467 8.90106C52.2287 8.85183 53.3649 8.84002 55.805 9.39382C59.3184 10.1912 58.8832 11.4859 58.8832 11.7316C58.8832 12.6853 58.9895 15.239 58.9895 16.0389Z"
          fill={fillColor}
          stroke="currentColor"
          strokeWidth="2.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.9221 13.3228C15.6244 12.9184 8.84417 12.2606 12.2908 4.98205C15.2764 -1.32305 23.3862 2.93552 22.8818 7.48468"
          stroke="currentColor"
          strokeWidth="2.7"
          strokeLinecap="round"
        />
        <path
          d="M43.0601 12.9589C40.9502 14.0647 34.8857 12.9591 36.7673 5.29455C38.4795 -1.68014 48.3689 3.16257 47.8416 7.90168"
          stroke="currentColor"
          strokeWidth="2.7"
          strokeLinecap="round"
        />
        <path
          d="M46.849 48.3732C19.7441 64.7436 7.75371 38.6975 20.7208 29.5301C33.6879 20.3627 46.2047 30.2667 45.3942 38.943C45.1468 41.5917 44.9789 42.4411 43.5171 45.0992"
          stroke="currentColor"
          strokeWidth="2.7"
          strokeLinecap="round"
        />
        <path
          d="M46.9487 48.4555C44.7575 47.5484 49.9682 61.9004 50.435 65.8326C50.435 65.8326 54.19 61.8691 57.582 60.1193C65.4263 56.0727 63.7391 52.9388 63.7391 52.9388C57.3811 50.8791 49.2048 49.3895 46.9487 48.4555Z"
          fill={fillColor}
          stroke="currentColor"
          strokeWidth="2.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M64.0156 53.215C66.9449 56.0066 71.2741 60.7732 72.486 62.5783M50.4349 65.9108C52.5266 68.5292 53.3258 69.7081 56.4487 72.4171"
          stroke="currentColor"
          strokeWidth="2.7"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.9113 42.7031H29.6746V36.2711C29.1078 36.5351 28.4701 36.7751 27.549 37.1111L26.25 33.7271L31.3279 32.1431H33.6897V42.7031H35.65V46.5431H26.9113V42.7031Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_11184_102378">
          <rect width="72" height="72" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CalendarAppointmentBoldIcon;
